import { CUSTOM_ROUTES, ResourceName } from "@/utils";
import { Message, PortraitRounded } from "@mui/icons-material";
import { FC } from "react";
import { Menu as RaMenu, useCanAccess } from "react-admin";

const CustomRoutesMenu: FC = () => {
  const { canAccess: hasUsersAnalyticsPageAccess } = useCanAccess({
    action: "custom-page",
    resource: ResourceName.USERS_ANALYTICS,
  });
  const { canAccess: hasSupportPageAccess } = useCanAccess({
    action: "custom-page",
    resource: ResourceName.SUPPORT,
  });

  return (
    <RaMenu>
      <RaMenu.ResourceItems />

      {hasUsersAnalyticsPageAccess && (
        <RaMenu.Item
          to={CUSTOM_ROUTES.ANALYTICS}
          primaryText="Users Analytics"
          leftIcon={<PortraitRounded />}
        />
      )}
      {hasSupportPageAccess && (
        <RaMenu.Item
          to={CUSTOM_ROUTES.SUPPORT}
          primaryText="Support"
          leftIcon={<Message />}
        />
      )}
    </RaMenu>
  );
};

export { CustomRoutesMenu };
